const hostNameParts = window.location.hostname.split(".");
const hostname =
  hostNameParts.length === 2 ? hostNameParts[0] : hostNameParts[1];

switch (hostname) {
  case "inburgeringonline":
    import(`../sass/inburgeringonline.scss`);
    break;
  case "staatsexamencursus":
    import(`../sass/staatsexamencursus.scss`);
    break;
  default:
    import("../sass/index.scss");
}
